export const BOOKMARKS_DESIGNATION = 'aubookmarks';
export const COLLECTIONS_PROVIDER = 'aws';
